<template>
  <div :class="$style.container">
    <img :src="icon" alt="">
    <p>{{ result }}</p>
    <p v-if="type == 1">请返回游戏重新进行授权</p>
    <p v-if="type == 2">无需重复授权</p>
    <p v-if="type == 3">该支付宝账号已授权其他游戏账号</p>
    <p v-if="type == 3">请返回游戏选择其它支付宝账号授权</p>
    <p v-if="type == 2 || type == 0">请返回游戏进行提现</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      result: '',
      type: '',
      icon: ''
    };
  },
  mounted() {
    const { type } = this.$route.query;
    this.type = type;
    if (type == 0) {
      this.result = '授权成功';
      this.icon = `${this.$cdnLink}/red-envelope/aliPay/1.jpg`
    } else if (type == 1) {
      this.result = '授权失败';
      this.icon = `${this.$cdnLink}/red-envelope/aliPay/2.jpg`
    } else if (type == 2) {
      this.result = '游戏账号已被授权';
      this.icon = `${this.$cdnLink}/red-envelope/aliPay/3.jpg`
    } else if (type == 3) {
      this.result = '授权失败';
      this.icon = `${this.$cdnLink}/red-envelope/aliPay/2.jpg`
    }
  },
  methods: {},
  components: {},
};
</script>
<style lang="scss" module>
.container {
  font-size: 20px;
  padding-top: 25%;
  > img {
    width: 100%;
    margin-bottom: 30px;
  }
  > p:nth-child(2) {
    font-size: 26px;
    text-align: center;
    font-weight: 500;
    margin-bottom: 15px;
  }
  > p {
    font-size: 20px;
    text-align: center;
    margin-bottom: 10px;
    font-weight: 300;
  }
}
</style>
